<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="filter-box">
      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item label="业务线">
          <el-select v-model="filters.bizLine" placeholder="全部" style="width: 130px">
            <el-option label="全部" value="ALL" />
            <el-option label="鉴别/寄售" value="XW" />
            <el-option label="闲置/安心购" value="SECONDHAND" />
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model.trim="filters.orderNo" placeholder="订单号" clearable style="width: 180px" />
        </el-form-item>
        <el-form-item label="退款单号">
          <el-input v-model.trim="filters.refundNo" placeholder="商户/渠道退款单号" clearable style="width: 200px" />
        </el-form-item>
        <el-form-item v-if="filters.bizLine !== 'SECONDHAND'" label="退款类型">
          <el-select v-model="filters.refundType" placeholder="全部" clearable style="width: 140px">
            <el-option label="鉴真费退款" value="IDENTIFY_FEE" />
            <el-option label="部分退款" value="PARTIAL" />
            <el-option label="全额退款" value="FULL" />
            <el-option label="调整退款" value="ADJUST" />
          </el-select>
        </el-form-item>
        <el-form-item label="退款时间">
          <el-date-picker
            v-model="filters.dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始"
            end-placeholder="结束"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            style="width: 340px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="resetFilters">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="id" label="ID" width="70" align="center" />
      <el-table-column label="业务线" width="90" align="center">
        <template slot-scope="scope">{{ bizLineLabel(scope.row.bizLine) }}</template>
      </el-table-column>
      <el-table-column label="退款时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column prop="orderNo" label="订单号" min-width="170" align="center" show-overflow-tooltip />
      <el-table-column prop="fatherOrderNo" label="父订单号" min-width="150" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.fatherOrderNo || "—" }}</template>
      </el-table-column>
      <el-table-column label="订单类型" width="110" align="center">
        <template slot-scope="scope">{{ scope.row.orderBizLabel || orderTypeLabel(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="退款金额" width="100" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.refundAmount) }}</template>
      </el-table-column>
      <el-table-column label="退款类型" width="120" align="center">
        <template slot-scope="scope">{{ refundTypeLabel(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="refundReason" label="退款原因" min-width="140" align="center" show-overflow-tooltip />
      <el-table-column label="支付渠道" width="90" align="center">
        <template slot-scope="scope">{{ gatewayLabel(scope.row.gatewayCode) }}</template>
      </el-table-column>
      <el-table-column prop="refundNo" label="商户退款单号" min-width="170" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.refundNo || "—" }}</template>
      </el-table-column>
      <el-table-column label="渠道退款单号" min-width="180" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.channelRefundId || scope.row.wxRefundId || "—" }}</template>
      </el-table-column>
      <el-table-column label="操作人" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.operatorName || scope.row.operatorId || "—" }}</template>
      </el-table-column>
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="mini">
            {{ scope.row.status === 1 ? "成功" : "失败" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="订单累计已退" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.bizLine === "XW" ? formatMoney(scope.row.refundedAmount) : "—" }}
        </template>
      </el-table-column>
    </el-table>

    <div class="page_box">
      <el-pagination
        @current-change="changePage"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="tableTotal"
      />
    </div>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  name: "XwOrderRefundRecord",
  data() {
    return {
      historyArr: ["退款管理", "退款流水"],
      loading: false,
      tableData: [],
      tableTotal: 0,
      currentPage: 1,
      pageSize: 20,
      filters: {
        bizLine: "ALL",
        orderNo: "",
        refundNo: "",
        refundType: "",
        dateRange: null,
      },
    };
  },
  mounted() {
    this.fetchList(1);
  },
  methods: {
    formatMoney(v) {
      if (v == null || v === "") return "—";
      const n = Number(v);
      return Number.isFinite(n) ? n.toFixed(2) : String(v);
    },
    formatTime(t) {
      if (!t) return "—";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },
    bizLineLabel(v) {
      if (v === "XW") return "鉴别/寄售";
      if (v === "SECONDHAND") return "闲置";
      return v || "—";
    },
    gatewayLabel(code) {
      if (code === "WECHAT") return "微信";
      if (code === "HUIFU") return "汇付";
      return code || "—";
    },
    refundTypeLabel(row) {
      if (!row) return "—";
      if (row.bizLine === "SECONDHAND") {
        const shMap = { 1: "仅退款", 2: "退货退款" };
        if (row.shRefundType != null && shMap[row.shRefundType]) {
          return shMap[row.shRefundType];
        }
        if (row.eventType === "HUIFU_REFUND_SUCCEEDED") return "网关退款成功";
        return row.eventType || row.refundType || "—";
      }
      const map = {
        IDENTIFY_FEE: "鉴真费退款",
        PARTIAL: "部分退款",
        FULL: "全额退款",
        ADJUST: "调整退款",
      };
      return map[row.refundType] || row.refundType || "—";
    },
    orderTypeLabel(row) {
      if (!row) return "—";
      if (row.bizLine === "SECONDHAND") return "闲置";
      const isConsign = String(row.sfjs) === "1";
      const base = isConsign ? "寄售" : "鉴别";
      if (row.consignMode === "REUSE_IDENTIFY") {
        return base + "·防伪码";
      }
      return base;
    },
    buildQuery(page) {
      const payload = {
        page: page || 1,
        size: this.pageSize,
        bizLine: this.filters.bizLine || "ALL",
      };
      if (this.filters.orderNo) payload.orderNo = this.filters.orderNo;
      if (this.filters.refundNo) payload.refundNo = this.filters.refundNo;
      if (this.filters.refundType) payload.refundType = this.filters.refundType;
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        payload.dateFrom = this.filters.dateRange[0];
        payload.dateTo = this.filters.dateRange[1];
      }
      return payload;
    },
    fetchList(page) {
      this.loading = true;
      this.$https(this.$api.api.xwOrderRefundRecordList, this.buildQuery(page), "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      this.currentPage = 1;
      this.fetchList(1);
    },
    resetFilters() {
      this.filters = {
        bizLine: "ALL",
        orderNo: "",
        refundNo: "",
        refundType: "",
        dateRange: null,
      };
      this.currentPage = 1;
      this.fetchList(1);
    },
    changePage(p) {
      this.currentPage = p;
      this.fetchList(p);
    },
  },
};
</script>

<style scoped lang="less">
.filter-box {
  margin: 12px 0;
  padding: 12px 12px 0;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
.page_box {
  margin-top: 16px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/xwOrderRefund/index.vue